import { Link, useParams } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import EventExplorer from "@/components/feature/EventExplorer";
import { Breadcrumb } from "@/components/base/Ui";
import { ErrorState } from "@/components/base/StateViews";
import { categories } from "@/mocks/categories";
import { useDocumentMeta } from "@/hooks/useDocumentMeta";

export default function CategoryPage() {
  const { categoryId = "" } = useParams();
  const category = categories.find((c) => c.id === categoryId);

  useDocumentMeta({
    title: category
      ? `${category.name}赛事资讯 - 51-每日大赛`
      : "赛事分类 - 51-每日大赛",
    description: category
      ? `${category.name}赛事最新资讯与比赛安排汇总。${category.desc}`
      : "51-每日大赛赛事分类页面，按赛事类别查看最新资讯与安排。",
    keywords: category
      ? `${category.name}赛事,${category.name}资讯,比赛安排,51-每日大赛`
      : "赛事分类,赛事资讯,51-每日大赛",
  });

  return (
    <Layout>
      <div className="mx-auto w-full px-4 py-8 md:px-6">
        <Breadcrumb
          items={[{ label: "首页", to: "/" }, { label: category ? `${category.name}资讯` : "赛事分类" }]}
        />

        {!category ? (
          <div className="mt-6">
            <ErrorState
              title="未找到该赛事分类"
              desc="你访问的分类不存在或已调整，返回首页选择其他赛事类别。"
              actionLabel="返回首页"
              onAction={() => {
                window.REACT_APP_NAVIGATE("/");
              }}
            />
          </div>
        ) : (
          <>
            <header className="mt-5 overflow-hidden rounded-lg border border-background-200 bg-background-50">
              <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between md:p-6">
                <div className="flex items-start gap-4">
                  <span className={`flex h-14 w-14 items-center justify-center rounded-xl text-2xl ${category.accent}`}>
                    <i className={category.icon}></i>
                  </span>
                  <div>
                    <h1 className="text-2xl font-extrabold tracking-tight text-foreground-950 md:text-3xl">
                      {category.name}赛事资讯
                    </h1>
                    <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{category.desc}</p>
                  </div>
                </div>
              </div>
              <div className="flex flex-wrap gap-2 border-t border-background-200 bg-background-100 px-5 py-3 md:px-6">
                {categories.map((c) => (
                  <Link
                    key={c.id}
                    to={`/category/${c.id}`}
                    className={`rounded-full px-3 py-1 text-xs font-medium transition-colors ${
                      c.id === category.id
                        ? "bg-primary-500 text-background-50"
                        : "bg-background-50 text-foreground-600 hover:bg-background-200"
                    }`}
                  >
                    {c.name}
                  </Link>
                ))}
              </div>
            </header>

            <div className="mt-6">
              <EventExplorer initialCategory={category.id} />
            </div>
          </>
        )}
      </div>
    </Layout>
  );
}